{
  "w": 32,
  "h": 20,
  "rows": [
    ".............KKKwwKKK...........",
    "...........KKwwwwwwwKK..........",
    "..........KKwwwwwwwwwwK.........",
    ".........KKwwwwwwwwwwwwK........",
    ".......K.KwWWWWWWWWWWWwK........",
    "...KKKKwKwwCwwwwwwwwwCwwK.......",
    "..KwwwwwKwwwwwwwwwwwwwKKKKKK....",
    ".KwwwwwwKwwwwwwwwwwwKKKwwwwKKK..",
    "KwWWWWWWKwwwwwwwwwwKKwwwwwwwwKK.",
    "KwCwwwwwKwwwwwwwwwwKWWWWWWWWWwK.",
    "wwwwwwwwKwwwwKwwKwKwCwwwwwwwCwwK",
    "wwwwwwwwKwwwwwKwwwKwwwwwwwwwwwwK",
    "wwwwwwwwKwwwwwKwwwKwwwwKwwwwwwwK",
    "wwwwwwwwKwwwwwwKwwKwwwwwKwwwwwwK",
    "wwwwwwwwwKwwwwwKwwKwwwwwKwwwwwwK",
    "KwwwwwwwwKwwwwwwKwKwwwwwwKwwwwwK",
    "KKwwwwwwwwKwwwwwKwwKwwwwwwKwwwK.",
    ".KKwwwwwwwwKwwwwwKwKKwwwwwKwKKK.",
    "..KKwwwwwwKKKKKwwwwKKKwwwwwKKK..",
    "....KKKKKK....KKKKK...KKKKKK...."
  ],
  "legend": {
    "K": "C.BLACK",
    "C": "C.B_CYAN",
    "W": "C.B_WHITE",
    "w": "C.WHITE"
  }
}
